import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function VideoPlayIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 34 34"
        {...props}
      >
        <path
          fill="#EB3C96"
          d="M17 33.667c9.205 0 16.667-7.462 16.667-16.667S26.205.333 17 .333.333 7.795.333 17 7.795 33.667 17 33.667"
        />
        <path
          fill="#FFDCB9"
          d="M24.44 15.55a1.666 1.666 0 0 1 0 2.9l-9.94 5.634a1.666 1.666 0 0 1-2.5-1.45V11.369a1.666 1.666 0 0 1 2.5-1.45z"
        />
      </svg>
    </Icon>
  )
}
export default VideoPlayIcon
